import React, { useState, useEffect } from "react";
import {
  Button,
  TextField, // Use TextField instead of TextareaAutosize
  InputLabel,
  DialogTitle,
  Dialog,
  Select,
  Box,
  MenuItem,
  FormControl,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Import useTheme
// Removed: import { makeStyles } from "@mui/styles";

import { useDispatch } from "react-redux";
import moment from "moment";
import { saveCurrentRecipe, updateDirection } from "../actions/recipes";
import { Close } from "@mui/icons-material";

// Note: No more useStyles definition needed

function EditDirection(props) {
  const { onClose, open, currentDirection, index } = props;
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme

  const [openOptions, setOptionsOpen] = React.useState(false);
  // Initialize state with default values to prevent potential null issues
  const [instruction, setInstruction] = useState(
    currentDirection.instruction || ""
  );
  const [optional, setOptional] = useState(currentDirection.optional === true);

  // --- useEffect to update state when currentDirection prop changes ---
  useEffect(() => {
    // Set direction information to state when prop changes
    setInstruction(currentDirection.instruction || "");
    // Convert string 'Yes'/'No' or boolean to boolean state
    setOptional(
      currentDirection.optional === true || currentDirection.optional === "Yes"
    );
  }, [currentDirection, index]);

  // --- Handlers ---
  const handleClose = () => onClose();
  const handleInstructionChange = (e) => setInstruction(e.target.value);
  const handleOptionsChange = (e) => setOptional(e.target.value);
  const handleOptionsClose = () => setOptionsOpen(false);
  const handleOptionsOpen = () => setOptionsOpen(true);

  // --- Submission Logic ---
  function editItem() {
    // creating a new direction object
    const newDirection = {
      instruction,
      // Ensure 'optional' is stored as a boolean (or string if required by the action)
      optional: optional,
    };

    dispatch(updateDirection(newDirection, index));
    dispatch(saveCurrentRecipe());

    handleClose();
  }

  // Define styles using the sx prop
  const closeButtonStyle = {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  };

  return (
    <Dialog
      maxWidth={"xs"}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="edit-direction"
      open={open}
    >
      <DialogTitle
        id="edit-direction"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3),
        }}
      >
        <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
          ✏️ Edit Direction Step {index !== undefined ? index + 1 : ""}
        </Typography>
        <IconButton
          aria-label="close"
          sx={closeButtonStyle}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <FormControl fullWidth sx={{ mb: 3 }}>
          <TextField
            label="Instruction"
            placeholder="Enter the instruction step"
            multiline
            rows={4}
            onChange={handleInstructionChange}
            value={instruction}
          />
        </FormControl>

        <FormControl fullWidth sx={{ mb: 4 }}>
          <InputLabel id="optional-label">Optional Step?</InputLabel>
          <Select
            labelId="optional-label"
            id="optional-select"
            label="Optional Step?"
            open={openOptions}
            onClose={handleOptionsClose}
            onOpen={handleOptionsOpen}
            onChange={handleOptionsChange}
            value={optional} // Value should be boolean
          >
            <MenuItem value={false}>No</MenuItem>
            <MenuItem value={true}>Yes</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          onClick={editItem}
          size="large"
          variant="contained"
          color="primary"
          sx={{ padding: theme.spacing(1, 4) }}
        >
          Save Changes
        </Button>
      </Box>
    </Dialog>
  );
}
export default EditDirection;
